/**
 * @file
 * @auth Tangting
 * @date 2016/12/29
 */

import Vue from 'vue';
import tpl from './tpl.html';
// import ContractInfo from './contractInfo/main'
import commonService from '../../common/commonService'
import Pager from '../../component/Pager.vue';
import parseUrl from '../../util/parseUrl';

export default Vue.extend({
    name: 'contract',
    template: tpl,
    data(){
        return {
            contractSearchTxt: '', // 文本框中变化的内容
            txt: '', // 点击搜索按钮 或回车查询的搜索内容
            hasDelete: this.contractSearchTxt,
            contractList: [],

            pageNo: 1,
            pageNum: 0,
            pageSize: 10,
        }
    },
    created() {
        if(localStorage.getItem('pageNo')){
            /**
             * 当从合约详情页返回的情况
             */
            this.contractSearchTxt = localStorage.getItem('contractSearchTxt');
            this.txt = this.contractSearchTxt;
            this.pageNo = +localStorage.getItem('pageNo');
            this.fetchContractList();
            localStorage.removeItem('contractSearchTxt');
            localStorage.removeItem('pageNo');
        }else{
            this.fetchContractList();
        }
    },
    mounted(){
        window.scrollTo(0,0);
    },
    watch: {
    },
    components: {
        Pager
    },
    methods: {
        // 获取合约列表
        fetchContractList(){
            commonService.contractInfo(
                {"keyword" : this.contractSearchTxt,"page" : +this.pageNo}
            ).done((rep)=>{
                this.toLoadList(rep);
            }).fail((rep)=> {
                window.error("网络异常，请稍后再试");
            });
        },

        // 点击搜索按钮 或回车调用的函数
        toSearchContract(){
            this.txt = this.contractSearchTxt; // 存储搜索的内容
            this.pageNo = 1;
            this.fetchContractList();
        },

        // 点击分页条调用的函数
        changeContractPage(){
            commonService.contractInfo(
                {"keyword" : this.txt,"page" : +this.pageNo}
            ).done((rep)=>{
                this.toLoadList(rep);
            }).fail((rep)=> {
                window.error("网络异常，请稍后再试");
            });
        },

        //接口调用成功后 公共逻辑
        toLoadList(rep){
            if(rep.result.dataList.length == 0){
                window.toast("没有查询到相关数据")
                return;
            }
            this.pageNum = Math.ceil(rep.result.total/this.pageSize);
            let listArr = rep.result.dataList;
            listArr.forEach(function(contract,index){
                let status = contract.status;
                listArr[index].status = status == 0?'销毁':status == 1?'临时':status == 2?'永久':'';
            });
            this.contractList = listArr;
        },

        // 跳转到合约详情页
        toContractInfo(parm){
            localStorage.setItem('contractSearchTxt',this.contractSearchTxt);
            localStorage.setItem('pageNo',this.pageNo);
            location.hash = '#/contractInfo?contract_id='+parm;
            // this.$router.push()
        },

        // 点击输入框中删除符号
        toReload(){
            this.contractSearchTxt = '';
        },

        // 点击分页条中的页码
        changePage(num){
            this.pageNo = num;
            this.changeContractPage();
        }
    }
});



// WEBPACK FOOTER //
// ./src/module/contract/main.js